<template>

</template>
<script>
import { getUserInfo } from "@/assets/js/until.js"
export default {
  data(){
    return {
      sgp_user: true,
      su_user: true,
      product_id: '',
      not_apply: false,
      sku_num: '',
      form: {
        token: '',
        timestamp: '',
        noncestr: '',
        AESData: ''
      },
      user_info: '',
      destination: '',
      course_url: ''
    }
  },
  methods: {
    jumpUrl(){
      const { redirect_url } = this.$route.query
      if (redirect_url) {
        window.location.href = redirect_url
        return
      }
      if(this.user_info.role == 31){
        // su用户 //从质检详情跳质检系统
        if(this.destination == 1){
          // 质检信息页面  >> 做过申请并通过
          if(this.sku_num){
            this.$router.push({name: 'manage-detail', query:{su_user: true, product_id: this.product_id,sku_num: this.sku_num}})
          }else {
            this.$router.push({name: 'manage-detail', query:{su_user: true, product_id: this.product_id}})
          }
        }else if(this.destination == 4){
          //质检订单页面
          this.$router.push({name: 'su-order-qualify', query: {su_user: true}})
        }
      }else if(this.user_info.role == 10){
        // sgp用户  //从质检详情跳质检系统
        //产品未申请过质检初审 >> 产品管理页面 并提示  该产品还未申请质检初审
        if(this.destination == 4){
          if(this.not_apply){
            //弹框  该产品还未申请质检初审
            this.$router.push({name: 'sgp-manage-product', query:{sgp_user: true, not_apply: this.not_apply}})
          }else{
            this.$router.push({name: 'sgp-manage-product', query:{sgp_user: true}})
          }
        }else if(this.destination == 1){
          //如果产品申请过质检初审并且已通过 跳转到质检信息页面
          this.$router.push({name: 'sgp-manage-detail', query:{sgp_user: true, product_id: this.product_id}})
        }else if(this.destination == 2){
        //产品申请过质检初审，还未通过，>> 跳转到审核产品页并检索出这个产品
          this.$router.push({name: 'examine-product', query: {sgp_user: true, sku_num: this.sku_num}})
        }
      } else if (this.user_info.role == 51) {
        if(this.destination == 5){
          this.$router.push({name: 'order-qualify', query: {tl_user: true}})
        } else {
          this.$router.push({name: 'order-qualify', query: {tl_user: true}})
        }
      }
    },
    isLognIn(){
      this.$axios.post((this.$httpConfig.COLA + '/api/cola/quality_test/login/'), this.form,
      {
        //转换请求数据
        transformRequest: (data) => { //data就是content
          return this.$qs.stringify(data) //最终请求体的数据
        }
      },
      ).then((res) => {
        if(res.data.code == this.ERRORCODE.SUCCESS){
          this.user_info = res.data.user_info
          // 是否是train具体课程页面
          const course_url = res.data.course_url
          if (course_url) {
            this.$router.push({ path: course_url, query: this.$route.query })
            return
          }
          this.jumpTo()
        } else if(res.data.code == 12){
          this.$message.error(res.data.msg_cn)
          let _this = this
          setTimeout(function(){
            window.location.href = this.$toLogin(window.location.href)
          }, 1500)
        } else{
          this.$message.error(res.data.msg_cn)
        }
      }).catch((err) => {
        this.$message.error('网络繁忙，请稍后再试...')
      })
    },
    jumpTo(){
      this.$axios.post((this.$httpConfig.COLA + '/api/cola/quality_test/page-of-jump/'), this.form,
      {
        //转换请求数据
        transformRequest: (data) => { //data就是content
          return this.$qs.stringify(data) //最终请求体的数据
        }
      }).then((res) => {
        if(res.data.code == this.ERRORCODE.SUCCESS){
          this.destination = res.data.destination
          this.product_id = res.data.product_id
          this.not_apply = res.data.no_apply
          this.sku_num = res.data.sku_num
          this.jumpUrl()
        }else{
          this.$message.error(res.data.msg_cn)
        }
      }).catch((err) => {
        this.$message.error('网络繁忙，请稍后再试...')
      })
    },
  },
  created(){
    this.form.timestamp = this.$getParameterByName('timestamp')
    this.form.token = this.$getParameterByName('token')
    this.form.noncestr = this.$getParameterByName('noncestr')
    this.form.AESData = this.$getParameterByName('AESData')
    if(this.form.token&&this.form.timestamp&&this.form.noncestr&&this.form.AESData){
      if (process.env.ENV_CONFIG !== 'dev' && this.$getCookie('dev') === '1') {
        window.location.href = `http://sws.etrip.life:8080/judge-road${window.location.search}`
        return
      }
      this.isLognIn()
    }else{
      window.location.href= this.$httpConfig.COLAHOST + 'Vendor/'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/judge-road.vue